'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'

const ScrollProgress = dynamic(
  () => import('@/components/ui/ScrollProgress').then(m => m.ScrollProgress),
  { ssr: false }
)
const ConversionWidgets = dynamic(
  () => import('@/components/conversion/ConversionWidgets').then(m => m.ConversionWidgets),
  { ssr: false }
)
const VapiWidgetLoader = dynamic(
  () => import('@/components/ui/VapiWidgetLoader').then(m => m.VapiWidgetLoader),
  { ssr: false }
)

// Partner landing pages with no pop-ups: no sticky bottom bar, scroll CTA,
// exit-intent modal or Vapi voice widget.
const NO_POPUP_PATHS = ['/biz-411', '/webinar']

/**
 * ClientShell — wraps non-critical client-only widgets that should be
 * dynamically imported with ssr:false. This must be a Client Component
 * because next/dynamic with ssr:false is not allowed in Server Components.
 */
export function ClientShell() {
  const pathname = (usePathname() || '/').replace(/\/+$/, '') || '/'
  const popups = !NO_POPUP_PATHS.includes(pathname)

  return (
    <>
      <ScrollProgress />
      {popups && <ConversionWidgets />}
      {popups && <VapiWidgetLoader />}
    </>
  )
}
